export const THONG_TIN_VAT_HANG_HOA_PERMISSION_CODES = {
  WEB_BH_THONG_TIN_VAT_HANG_HOA_LIST: 'WEB_BH_THONG_TIN_VAT_HANG_HOA_LIST',
  WEB_BH_THONG_TIN_VAT_HANG_HOA_ADD: 'WEB_BH_THONG_TIN_VAT_HANG_HOA_ADD',
  WEB_BH_THONG_TIN_VAT_HANG_HOA_EDIT: 'WEB_BH_THONG_TIN_VAT_HANG_HOA_EDIT',
  WEB_BH_THONG_TIN_VAT_HANG_HOA_DELETE: 'WEB_BH_THONG_TIN_VAT_HANG_HOA_DELETE',
  WEB_BH_THONG_TIN_VAT_HANG_HOA_IMPORT: 'WEB_BH_THONG_TIN_VAT_HANG_HOA_IMPORT',
  WEB_BH_THONG_TIN_VAT_HANG_HOA_EXPORT: 'WEB_BH_THONG_TIN_VAT_HANG_HOA_EXPORT',
} as const
